import styled from '@emotion/styled';
import { nike } from '@nike/nike-design-tokens';

const { podiumCdsBreakpointXs } = nike;

const stepperCSS = styled('div');
export const StepperCss = stepperCSS`
    display: flex;
    align-items: center;
    min-width: ${podiumCdsBreakpointXs};
`;
